import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  // Release should match the version when deploying
  // Set this via environment variable or package.json version
  release: import.meta.env.VITE_RELEASE || 'unknown',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Replay disabled - using PostHog for session recording instead
  ],
  tracesSampleRate: 0.1,
});
